// Library Utilities
import React from "react";
import { Link } from "react-router-dom";

// styles
import Styles from "./service-info-cards.module.scss";
import { IdsGenerator } from "../../../../utils/idGenerator";
import { productName } from "../../../../utils/dashboardMappers";
import { cn } from "../../../../Shared/utils";
import { buttonStyles, StyledButton } from "../../../../Shared/button/button";

function ServiceInfoCards({
  uniqueId,
  handleServicePopup,
  serviceInfo = {},
  browse,
}: any) {
  function handleBrowseServices() {}
  const browseProductsId = IdsGenerator({
    prefix: "service-info-card",
    id: "click",
    suffix: "browse all products",
  });
  const displayName = productName(serviceInfo);

  return (
    <div
      className={`${Styles.serviceInfoCard} d-flex flex-column justify-content-between`}
    >
      {!browse && (
        <>
          <div className="d-flex flex-column">
            <p className="title_bold_text">{displayName}</p>
            <p className={Styles.serviceDesc}>
              {serviceInfo.short_description}
            </p>
          </div>
          <div className="d-flex flex-column">
            {/* <div className="d-flex flex-row  align-items-center gap-2">
              <p className={`${Styles.avalCreds}`}>Available Credits:</p>
              <p
                className={Styles.creditsInfo}
                id={IdsGenerator({
                  prefix: "service-info-card",
                  id: "available credits",
                  suffix: displayName,
                })}
              >
                {serviceInfo.remaining_test_credits}
              </p>
            </div> */}
            {/* <div className="d-flex justify-content-end align-content-end"> */}
            <StyledButton
              id={IdsGenerator({
                prefix: "service-info-card",
                id: "click",
                suffix: displayName,
              })}
              className={cn(Styles.trialButton)}
              onClick={() => handleServicePopup(serviceInfo)}
              style={{ ...buttonStyles.borderLight.normal }}
              hoverStyle={{ ...buttonStyles.borderLight.hover }}
            >
              Run Trial
            </StyledButton>
            {/* </div> */}
          </div>
        </>
      )}
      {browse && (
        <Link
          to="/application/product-catalog"
          className={`d-flex flex-column justify-content-center align-items-center text-decoration-none outline-none ${Styles.browseButtonContainer}`}
          id={browseProductsId}
          data-testid={browseProductsId}
          onClick={() => handleBrowseServices()}
        >
          <div className={Styles.browseButton}>+</div>
          <p className="text-decoration-none outline-none m-0 p-0">
            Browse Products
          </p>
        </Link>
      )}
    </div>
  );
}

export default ServiceInfoCards;
